import { BrowserRouter } from 'react-router-dom'
import { useEffect } from 'react'
import Routes from 'Routes'
import { Store } from 'core'
import { InitialScrollToTop } from 'components'
import analyticsService from 'services/analytics'

const App = () => {
  useEffect(() => {
    // Initialize analytics session tracking
    analyticsService.initSession()
  }, [])

  return (
    <BrowserRouter>
      <Store>
        <InitialScrollToTop />
        <Routes />
      </Store>
    </BrowserRouter>
  )
}

export default App
